
import React from "react"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
import { GatsbyImage } from "gatsby-plugin-image"
import CarouselItemBg from "components/shared/CarouselItemBg"
import Button from 'components/shared/Button'

const ArticleStyled = styled.article`
	margin-bottom: 0;		
	width: 100%;
	display: block;
	position: relative;

	${props => props.type === "ColumnedImageWithText" && css`
		filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.15));
		display: flex;
		flex-direction: column;
	`}

	&:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background-image: ${props => props.theme.colors.gradient};
		
		${props => props.type === "ColumnedImageWithText" && css`
			background-image: none;
		`}
	}

	> a {
		/* line-height: 0; */
		display: block;
		text-decoration: none!important;
	}

	p.date {
		font-size: ${props => props.theme.font.size.base};
	}

	h2 {
		font-size: ${props => props.theme.font.size.md};
		font-family: ${props => props.theme.font.family.heading};
		text-transform: uppercase;
		color: ${props => props.theme.colors.tertiary}; 
		margin: 0;
		padding: 0;
		
		${props => props.type === "WpRecipe" && css`
			color: ${props => props.theme.colors.black}; 
		`}
		
		${props => props.type === "WpThingtodo" && css`
			color: ${props => props.theme.colors.purple}; 
		`}
		
		${props => props.type === "ColumnedImageWithText" && css`
			color: ${props => props.theme.colors.tertiary};
		`}
		
		a {
			text-decoration: none;
			${props => props.type === "WpRecipe" && css`
				color: ${props => props.theme.colors.black}; 
			`}
			
			${props => props.type === "WpThingtodo" && css`
				color: ${props => props.theme.colors.purple}; 
			`}
			
			${props => props.type === "ColumnedImageWithText" && css`
				color: ${props => props.theme.colors.primary};
			`}
		}
	}

	p.more {  
		font-size: ${props => props.theme.font.size.base};
	}


	.gatsby-image-wrapper {
		-webkit-transform: translate3d(0,0,0);
	}

	.news-content {
		position: absolute;
		padding: 1rem;
		bottom: 1rem;
		left: 1rem;
		width: calc(100% - 2rem);
		background-color: white;
		color: black;
		font-size: ${props => props.theme.font.size.sm};
		z-index: 10;
		-webkit-backface-visibility: hidden;
		-webkit-transform: translate3d(0,0,0);
		
		${props => props.type === "ColumnedImageWithText" && css`
		position: relative;
		bottom: 0;
		left: 0;
		width: 100%;
		flex-grow: 1;
		`}
		
		p {
			&:last-child {
				margin: 0;
			}
		}
	}

	&:hover {
		${props => props.borderOnHover === "yes" && css`
		border: 4px solid yellow;
		`}
		
		.hoverBg {
			opacity: 1;
		}
		.urgency-label {
			@media ${media.md} {
				display: none;
			}
		}
	}
` 

const CarouselItem = (props) => {
	return(
		<ArticleStyled type={props.type}>
			{props.image && props.image.localFile &&
				<Link to={props.url} className="position-relative">
						<GatsbyImage
							image={props.image.localFile.childImageSharp.gatsbyImageData}
							alt={props.image.altText}
						/> 
						{props.url &&
							<CarouselItemBg 
								className="hoverBg" 
								borderOnHover={props.borderOnHover}
								type={props.type}
							>
								<div>Read More</div>
							</CarouselItemBg>
						}
						<div className="news-content">
							{/* {props.url && props.title ? (
								<h2>
									<Link to={props.url}>
										{props.title}
									</Link>
								</h2>
							) : ( */}
								{/* <> */}
									{props.title && 
										<h2 className="baseSubtitle">
											{props.title}
										</h2>
									}
								{/* </> */}
							{/* )}  */}
							{props.excerpt && 
								<div dangerouslySetInnerHTML={{ __html: props.excerpt }} className="pt-2 baseText" />
							}
						</div>
				</Link>
			}
		</ArticleStyled>
	)
}

export default CarouselItem